package one.healthium.bland.presentation.navigation.main

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.catch
import one.healthium.domain.user.UserInteractor
import one.healthium.ui.common.vm.BaseViewModel

class MainViewModel(
    private val userInteractor: UserInteractor,
) : BaseViewModel() {
    init {
        launch {
            userInteractor.syncHealthData()
                .catch { Logger.e("Error syncing health data", it) }
                .collect {
                    Logger.d("Health data synced")
                }
        }
        launch {
            userInteractor.updateSystemData()
                .catch { Logger.e("Error syncing health data", it) }
                .collect {
                    Logger.d("System data updated")
                }
        }
    }
}